/*
      ___           ___
     /\  \         /\  \
    /::\  \       /::\  \
   /:/\:\  \     /:/\ \  \
  /::\ \:\  \   _\:\ \ \  \
 /:/\:\ \:\__\ /\ \:\ \ \__\
 \/_|::\/:/  / \:\ \:\ \/__/
    |:|::/  /   \:\ \:\__\
    |:|\/__/     \:\/:/  /
    |:|  |        \::/  /
     \|__|         \/__/

    Developed by Ralph Shippam - 2019.
*/

import {Component, ElementRef, EmbeddedViewRef, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogRef} from '@angular/material/dialog';
import {RSDialog} from "./rsdialog";
import {RSDialogComponentModel} from './rsdialog.component.model';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
    selector: 'rs-dialog',
    templateUrl: 'rsdialog.component.html',
    styleUrls: ['rsdialog.component.scss'],
    exportAs: 'RSDialogComponent'
})
export class RSDialogComponent implements OnInit {
    @ViewChild('component', {static: true}) componentContainer: ElementRef;
    @ViewChild(MatDialogActions, { read: ElementRef }) actionButtons: ElementRef;

    public panelOpenState$: boolean;
    public inputTypes$ = RSDialog.InputType;
    public defaultValues$ = RSDialog.defaultValues;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private sanitizer: DomSanitizer
    ) {}

    ngOnInit() {
        // Assign the componentRef
        if (this.data.component) {

            // Get DOM element from component
            const domElem = (this.data.component.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;

            // Append DOM element to the body
            this.componentContainer.nativeElement.appendChild(domElem);

            // Trigger changes now we're visible. Any earlier can cause issues with view children
            this.data.component.changeDetectorRef.detectChanges(); // update it's view
        }

        // Do we need to show this as HTML
        if (this.data.html) {
            this.data.message = this.sanitizer.bypassSecurityTrustHtml(this.data.message);
        }
    }

    onScrollTO;
    onScrollLast;
    onScroll(event) {
        // Ensure they've set this up
        if (this.data.component && this.data.component.instance && this.data.component.instance.dialogHandles) {
            // Store location
            this.onScrollLast = event;

            // Are we mid throttle?
            if (this.onScrollTO) {
                return;
            }

            // Throttle
            const throttle = 250;
            this.onScrollTO = setTimeout(() => {
                this.onScrollTO = null;
                this.data.component.instance.dialogHandles.onScroll.next(this.onScrollLast);
            }, throttle);
        }
    }

    /*public setButtonFocus() {
        // We are unable to utilise the Angular Accessibility methods
        // (cdkFocusRegionStart, cdkFocusRegionEnd & cdkFocusInitial) for some reason. Manual hack to handle this;
        if (this.actionButtons && this.actionButtons.nativeElement.children) {
            this.actionButtons.nativeElement.children[this.actionButtons.nativeElement.children.length - 1].focus();
        }
    }*/

}
